export default "__VITE_ASSET__BH6QJ3MV__"